import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MESSAGE_TYPE, updateChatEvent } from '../../../actions';
import BotMessage from './bot';
import TextMessage from './text';
import Buttons from './buttons';
import AddressForm from './addressForm';
import AttachmentMessage from './attachment';
import * as MainActions from '../../../../../main/actions';
import { MAIN_ACTIONS } from '../../../../../main/types';
import { APISubmode } from '../../../../../../api/types';
import { CHAT } from '../../../types';
import IPC from '../../../../../../helpers/ipc';
import { WIDGET_ACTIONS } from '../../../../../layers/widget/types';
import * as WidgetActions from '../../../../../layers/widget/actions';
import { VIEWS, VIEW_MODES } from '../../../../types';
import MaxIcon from '../../../../../../common/icons/max.svg';
import WDIcon from '../../../../../../common/icons/wd-small.svg';
import './style.scss';

const SELF_OPEN_URLS = [
    'www.orange.pl/zaloguj.phtml',
    'www.orange.pl/twojekonto/zaloguj',
    'www.orange.pl/moj-orange/logout',
    'www.orange.pl/kontakt',
    'www.orange.pl/hapi/'
];

const isSelfOpenUrl = (url) => {
    let isSelfOpen = false;
    SELF_OPEN_URLS.forEach((u) => {
        if (url.match(new RegExp(`^http[s]{0,1}://${u}`, 'g'))) {
            isSelfOpen = true;
        }
    });
    return isSelfOpen;
};

class Message extends React.Component {
    static getFirstName(firstAndLastName) {
        if (firstAndLastName === CHAT.WIRTUALNY_KONSULTANT) {
            return firstAndLastName;
        }
        if (!firstAndLastName) firstAndLastName = '';
        const a = firstAndLastName.split(' ');
        const username = a[0] || firstAndLastName;
        return username === 'User' ? 'Ty' : username;
    }

    onMessageClick(e, id) {
        if (
            (this.props.chat.submode === APISubmode.MAX ||
                this.props.chat.agent.name === CHAT.WIRTUALNY_KONSULTANT) &&
            e.target.tagName === 'A' &&
            isSelfOpenUrl(e.target.href)
        ) {
            e.preventDefault();
            IPC.sendEvent(MAIN_ACTIONS.OPEN_URL, {
                url: e.target.href,
                self: true
            });
        } else if (e.target.tagName === 'IMG' || e.target.tagName === 'path') {
            let element = e.target.parentElement;
            while (element) {
                if (element.tagName === 'A')
                    // avoid fullscreen on image links
                    return;
                if (element.attributes['allowfullscreen'] !== undefined) break;
                element = element.parentElement;
            }
            if (element) {
                let container = e.target.parentElement;
                while (container) {
                    if (
                        container.className &&
                        container.className.match &&
                        container.className.match('message-container')
                    ) {
                        break;
                    }
                    container = container.parentElement;
                }
                // const imgs = container.getElementsByTagName('img');
                const imgs = container.querySelectorAll('img, iframe[class="externalvideo"]');
                const data = [];
                for (let i = 0; i < imgs.length; i++) {
                    if (imgs[i].className !== 'emoji') {
                        let type =
                            imgs[i].tagName === 'IMG'
                                ? 'img'
                                : imgs[i].tagName === 'IFRAME'
                                ? 'externalvideo'
                                : 'none';
                        let src = imgs[i].attributes['src']
                            ? imgs[i].attributes['src'].value
                            : null;
                        let isExternalVideo = false;
                        if (imgs[i].dataset['src']) {
                            isExternalVideo = true;
                            type = 'externalvideo';
                            src = imgs[i].dataset['src'];
                        }
                        const title = imgs[i].attributes['title']
                            ? imgs[i].attributes['title'].value
                            : null;
                        const alt = imgs[i].attributes['alt']
                            ? imgs[i].attributes['alt'].value
                            : null;
                        data.push({
                            type: type,
                            src: src,
                            title: title,
                            alt: alt,
                            selected:
                                imgs[i] === e.target ||
                                (isExternalVideo && imgs[i].parentElement.contains(e.target))
                        });
                    }
                }
                if (data.length > 0) {
                    MainActions.onOpen({
                        config: {
                            defaultView: 'previewPopup',
                            previewOptions: data
                        }
                    });
                }
            }
        } else if (e.target.tagName === 'A') {
            const links = [
                {
                    regexp: new RegExp(/form:(.*)$/g),
                    exec: (match) => {
                        IPC.sendEvent(WIDGET_ACTIONS.OPEN_POPUP, {
                            type: 'form',
                            payload: { id: match }
                        });
                    }
                },
                {
                    regexp: new RegExp(/view:(.*)$/g),
                    exec: (match) => {
                        switch (match) {
                            case 'save':
                                WidgetActions.onSwitchView({
                                    view: VIEWS.CHAT_SAVE,
                                    mode: VIEW_MODES.MAXIMIZED
                                });
                                break;
                            case 'questionnaire':
                                WidgetActions.onSwitchView({
                                    view: VIEWS.QUESTIONNAIRE,
                                    mode: VIEW_MODES.MAXIMIZED
                                });
                                break;
                            case 'deviceConfig': {
                                if (!id) {
                                    return;
                                }

                                const getDeviceConfig = (messageId) => {
                                    const message = this.props.chat.messages.find(
                                        (m) => m.id === messageId
                                    );

                                    return (
                                        message &&
                                        message.customMessage &&
                                        message.customMessage.payload &&
                                        message.customMessage.payload.options
                                    );
                                };
                                const deviceConfig = getDeviceConfig(id);

                                MainActions.onOpen({
                                    config: {
                                        defaultView: 'previewPopup',
                                        previewOptions: [
                                            {
                                                type: 'html',
                                                ...deviceConfig
                                            }
                                        ]
                                    }
                                });
                                break;
                            }
                        }
                    }
                }
            ];

            links.forEach((l) => {
                const match = l.regexp.exec(e.target.href);
                if (match && match.length > 1) {
                    l.exec(match[1]);
                    e.preventDefault();
                }
            });
        }
    }

    render() {
        const { message, active, disabled } = this.props;

        const renderMessage = (message) => {
            switch (message.type) {
                case MESSAGE_TYPE.BOT_MESSAGE:
                    return (
                        <BotMessage
                            active={active}
                            message={message.message}
                            onSend={this.props.onSend}
                            onClick={(e) => this.onMessageClick(e)}
                        />
                    );

                case MESSAGE_TYPE.FILE_UPLOADED:
                    return (
                        <AttachmentMessage
                            message={message.message}
                            data={message.customMessage}
                            progress={message.progress || null}
                            API={this.props.API}
                            onClick={(e) => this.onMessageClick(e)}
                            disabled={this.props.disabled}
                        />
                    );

                case MESSAGE_TYPE.BUTTONS:
                    return (
                        <Buttons
                            id={message.id}
                            disabled={disabled}
                            options={message.customMessage.payload.options}
                            groupOptionsByCount={message.customMessage.payload.groupOptionsByCount}
                            onSelect={(id) => {
                                this.props.dispatch(
                                    updateChatEvent({
                                        ...message,
                                        hidden: true
                                    })
                                );
                                this.props.onSend(id);
                            }}
                        />
                    );

                case MESSAGE_TYPE.ADDRESS_FORM:
                    return (
                        <AddressForm
                            disabled={disabled}
                            onSubmit={(address) => {
                                this.props.dispatch(
                                    updateChatEvent({
                                        ...message,
                                        hidden: true
                                    })
                                );
                                this.props.onSend(address);
                            }}
                            onChange={(text) => this.props.API.sendTyping(text)}
                        />
                    );

                default:
                    return (
                        <TextMessage
                            id={message.id}
                            message={message.message}
                            type={message.type}
                            icon={message.icon}
                            onClick={(e, id) => this.onMessageClick(e, id)}
                        />
                    );
            }
        };

        const message_type = message.type || '';
        const grouped =
            this.props.prevMessage &&
            this.props.prevMessage.from === message.from &&
            message.from !== 'system';
        const typeClassName = `opl-widget-chat--message opl-widget-chat--message_${
            message.from
        } opl-widget-chat--message-type_${message_type.toLowerCase()} ${grouped ? 'grouped' : ''}`;

        return (
            <li className={typeClassName}>
                {(message.timestamp || message.username) && (
                    <h1
                        className={`opl-widget-chat--message-header ${
                            message.username === CHAT.WIRTUALNY_KONSULTANT
                                ? 'opl-widget-chat--message-header-wd'
                                : ''
                        }`}
                    >
                        {(message.username && (
                            <span className="opl-widget-chat--message-header-author">
                                {Message.getFirstName(message.username)}
                            </span>
                        )) || <span></span>}
                        {(message.timestamp && (
                            <span className="opl-widget-chat--message-header-time">
                                {new Date(message.timestamp).toLocaleTimeString()}
                            </span>
                        )) || <span></span>}
                        <span></span>
                    </h1>
                )}
                {(message.from === 'agent' && message.username === CHAT.WIRTUALNY_KONSULTANT && (
                    <div className="opl-widget-chat--message-container">
                        <div className="opl-widget-chat--message-icon">
                            <WDIcon />
                        </div>
                        <div
                            className={`opl-widget-chat--message-text opl-widget-chat--message-text_${message.from} opl-widget-chat--message-text_${message.from}_max`}
                        >
                            {renderMessage(message)}
                        </div>
                    </div>
                )) ||
                    (message.from === 'agent' && message.max && (
                        <div className="opl-widget-chat--message-container">
                            <div className="opl-widget-chat--message-icon">
                                <MaxIcon />
                            </div>
                            <div
                                className={`opl-widget-chat--message-text opl-widget-chat--message-text_${message.from} opl-widget-chat--message-text_${message.from}_max`}
                            >
                                {renderMessage(message)}
                            </div>
                        </div>
                    )) || (
                        <div
                            className={`opl-widget-chat--message-text opl-widget-chat--message-text_${message.from}`}
                        >
                            {renderMessage(message)}
                        </div>
                    )}
            </li>
        );
    }
}

Message.defaultProps = {
    message: {},
    active: false,
    disabled: false,
    onSend: null
};

Message.propTypes = {
    message: PropTypes.object.isRequired,
    active: PropTypes.bool,
    onSend: PropTypes.func,
    disabled: PropTypes.bool
};

const mapStateToProps = (state) => {
    return {
        theme:
            state.settings.widget && state.settings.widget.theme
                ? state.settings.widget.theme.split(' ')
                : ['default'],
        chat: state.chat
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Message);
